import { Icon } from '@/components/icon';

export function PlannedPage({ title, description, items }: {
  title: string;
  description: string;
  items: readonly string[];
}) {
  return <div className="page planned-page">
    <header className="page-heading">
      <div>
        <p className="eyebrow">Planned</p>
        <h1>{title}</h1>
        <p>This section is reserved in the information architecture and will activate when its source facts are trustworthy.</p>
      </div>
    </header>
    <section className="planned-details-card">
      <span className="planned-details-card__icon"><Icon name="clock" size={32} /></span>
      <h2>{title}</h2>
      <p>{description}</p>
      <ul>
        {items.map((item) => <li key={item}><Icon name="check" size={20} /><span>{item}</span></li>)}
      </ul>
    </section>
  </div>;
}
